import './about.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { SectionHeader } from '../components/SectionHeader'
import { HudCard } from '../components/HudCard'
import { MonoKicker } from '../components/MonoTag'

// 07 · VỀ ARGO — chiến lược tích hợp (không cạnh tranh) + mô hình B2B.
export default function About() {
  const { lang } = useI18n()
  const C = ({
    vi: {
      kicker: 'VỀ ARGO',
      title: <>Làm chủ chặng cuối, <em>ngay tại nguồn</em>.</>,
      sub: 'ARGO không thay thế hệ thống bạn đang chạy. Chúng tôi lo phần khó nhất — bằng chứng tuân thủ tại gốc — rồi giao dữ liệu sạch cho phần còn lại.',
      p1: 'Chiến lược của ARGO là tích hợp, không cạnh tranh. Dữ liệu vùng trồng đã chuẩn hóa — Lot Passport kèm GeoJSON — chảy thẳng vào nền tảng truy xuất mà nhà nhập khẩu EU đang dùng, sẵn sàng để nộp DDS qua TRACES NT mà không cần làm lại quy trình.',
      p2: 'Mô hình vận hành là B2B: bên cầu — nhà rang xay, nhà xuất khẩu, nhà phân phối — là bên trả tiền cho lớp bằng chứng tuân thủ. Nhờ đó, hợp tác xã được số hóa miễn phí và mở thêm kênh bán với mức giá tốt hơn cho cà phê đạt chuẩn.',
      statHead: <>// CẤU TRÚC</>,
      stats: [
        { label: 'Lớp tích hợp', val: 1, dec: 0, suf: '', sub: 'TRACES NT · DDS-ready' },
        { label: 'HTX số hóa', val: 0, dec: 0, pre: '', suf: '₫', sub: 'miễn phí cho bên cung' },
        { label: 'Bên trả phí', val: 100, dec: 0, suf: '%', sub: 'bên cầu (B2B)' },
      ],
      note: 'Số liệu mang tính minh họa cho mô hình.',
    },
    en: {
      kicker: 'ABOUT ARGO',
      title: <>Own the last mile, <em>right at the source</em>.</>,
      sub: 'ARGO does not replace the systems you already run. We handle the hard part — proof of compliance at origin — then hand clean data to the rest.',
      p1: 'ARGO is built to integrate, not to compete. Standardized plot data — a Lot Passport with GeoJSON — flows straight into the traceability platform an EU importer already uses, ready to file a DDS through TRACES NT without reworking the process.',
      p2: 'The model is B2B: the demand side — roasters, exporters, distributors — pays for the compliance-proof layer. That lets cooperatives go digital for free and open a better-priced sales channel for verified coffee.',
      statHead: <>// STRUCTURE</>,
      stats: [
        { label: 'Integration layer', val: 1, dec: 0, suf: '', sub: 'TRACES NT · DDS-ready' },
        { label: 'Co-op onboarding', val: 0, dec: 0, pre: '$', suf: '', sub: 'free for supply side' },
        { label: 'Who pays', val: 100, dec: 0, suf: '%', sub: 'demand side (B2B)' },
      ],
      note: 'Figures are illustrative of the model.',
    },
  } as const)[lang]

  return (
    <section id="about" className="section about">
      <div className="container">
        <SectionHeader index="08" kicker={C.kicker} title={C.title} sub={C.sub} />

        <div className="about-body">
          <Reveal className="about-copy" delay={0.06} y={20}>
            <p>{C.p1}</p>
            <p>{C.p2}</p>
          </Reveal>

          <Reveal className="about-side" delay={0.14} y={20}>
            <HudCard header={C.statHead} brackets>
              <ul className="about-stats">
                {C.stats.map((s) => (
                  <li className="about-stat" key={s.label}>
                    <span className="about-stat-val num">{('pre' in s ? s.pre : '')}{s.val}{s.suf}</span>
                    <span className="about-stat-label">{s.label}</span>
                    <span className="about-stat-sub mono">{s.sub}</span>
                  </li>
                ))}
              </ul>
              <MonoKicker className="about-note">{C.note}</MonoKicker>
            </HudCard>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
